import { configureStore } from '@reduxjs/toolkit';
import appReducer from './app/appReducer';
import createSagaMiddleware from 'redux-saga';
import enrollmentReducer from './enrollment/enrollmentReducer';
import modalReducer from './modal/modalReducer';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    app: appReducer,
    enrollment: enrollmentReducer,
    modal: modalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          '@enrollment/UPLOAD_TEMPLATE_FILE',
          '@enrollment/SET_ACTIVE_STEP',
        ],
        ignoredActionPaths: ['payload.callback', 'payload.onConfirm'],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type ApplicationState = ReturnType<typeof store.getState>;

export default store;
